import * as React from "react";
import { CSSTransition } from "react-transition-group";
import {
  galleryButtonInPreviewTransitionDuration,
  galleryButtonInPreviewTransitionClassName,
} from "../../../AppGallery";
import type { AppPreviewGalleryButtonDisplayState } from "./AppPreviewGalleryButtonDisplay.types";
import {
  AppGalleryButton,
  type AppGalleryButtonProps,
} from "../../../AppGalleryButton/next";

/**
 * Create the list of galleryButtons to show in the preview gallery.
 */
export const renderPreviewButtons = (
  state: AppPreviewGalleryButtonDisplayState
): JSX.Element[] => {
  const {
    animate,
    disabled,
    galleryButtons,
    onGalleryButtonExecute,
    contextMenuMap,
    onFocus,
    onBlur,
    location,
    selectedId,
  } = state;

  return galleryButtons.map((galleryButton, index) => {
    const galleryButtonProps = {
      ...galleryButton,
      index,
      id: galleryButton.id,
      disabled: disabled || galleryButton.disabled,
      onFocus,
      onBlur,
      onExecute: onGalleryButtonExecute,
      location,
      selected: selectedId === galleryButton.id,
      key: galleryButton.id + "-" + index,
      role: "radio",
      ariaLabel: galleryButton.label,
      shouldTakeFocus:
        galleryButton.shouldTakeFocus !== undefined
          ? galleryButton.shouldTakeFocus
          : true,
      contextMenuMap,
      isPreviewGalleryButton: true,
      size: state.size,
    } as AppGalleryButtonProps;

    const GalleryButtonTag =
      state.getGalleryButtonComponent || AppGalleryButton;
    const galleryButtonContent = (
      <GalleryButtonTag key={galleryButtonProps.key} {...galleryButtonProps} />
    ) || (
      <AppGalleryButton key={galleryButtonProps.key} {...galleryButtonProps} />
    );

    return !!animate ? (
      <CSSTransition
        key={galleryButtonProps.key}
        timeout={galleryButtonInPreviewTransitionDuration}
        classNames={galleryButtonInPreviewTransitionClassName}
        enter={animate}
        exit={animate}
      >
        {galleryButtonContent}
      </CSSTransition>
    ) : (
      galleryButtonContent
    );
  });
};
